export default "__VITE_ASSET__c753ab29__"